import React, {useEffect} from 'react';
import {useFilePicker} from "use-file-picker";
import {Button} from "@nextui-org/react";
import {Upload} from "@mui/icons-material";
import ReactSkinview3d from "react-skinview3d";
import {useWindowSize} from "@uidotdev/usehooks";
import Footer from "../Components/Footer";

function SkinViewer(props) {

    const [openFileSelector, {filesContent, loading}] = useFilePicker({
        accept: '.png',
        readAs: 'DataURL',
    });
    useEffect(() => {
        console.log(filesContent);
    }, [filesContent]);
    const size = useWindowSize();

    return (
        <div style={{height:"84vh"}}>
            <div className={'h-full w-screen flex  mx-auto flex-col justify-center items-center'}>
                {
                    filesContent.length === 0 ? <div>
                        <Button onClick={openFileSelector} color={'success'} variant={'ghost'} startContent={<Upload/>}>
                            <input style={{display: 'none'}} type="file"/>
                            Select your Skin File
                        </Button>
                    </div> : <ReactSkinview3d

                        skinUrl={filesContent[0].content}
                        capeUrl={''}
                        height={size.height / 3} width={size.width / 3}/>
                }


                {
                    filesContent.length === 0 ? <div/> :
                        <Button className={'sm:w-3/12'} onClick={openFileSelector} color={'success'} variant={'ghost'}
                                startContent={<Upload/>}>
                            <input style={{display: 'none'}} type="file"/>
                            Preview More Skins
                        </Button>
                }
            </div>
            <Footer/>
        </div>
    );
}

export default SkinViewer;